export default "__VITE_ASSET__DSjvOBuA__"